import { useState } from "react";

export default function ShowMoreHtml({ html, maxLength = 400 }) {
  const [expanded, setExpanded] = useState(false);
  // Remove HTML tags for length calculation
  const plainText = html.replace(/<[^>]+>/g, "");
  const isLong = plainText.length > maxLength;
  return (
    // Colour is inherited from the caller rather than set here, so the PDP's
    // `text-ink-2` overview panel and the listing's own tone both come through. It
    // used to hardcode `text-gray-700`, which won over whatever wrapped it.
    <div className="mt-[var(--space-4)] text-base">
      {isLong && !expanded ? (
        <span>{plainText.slice(0, maxLength)}... </span>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: html }} />
      )}
      {isLong && (
        <button
          type="button"
          className="ml-[var(--space-2)] cursor-pointer border-0 bg-transparent p-0 font-sans text-sm font-semibold text-ink-link underline [transition:color_var(--duration-fast)] hover:text-blue-800 focus-visible:rounded-sm focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}
